import type { EndorsementsLayoutPageDataQuery } from './endorsementsLayoutPageData.graphql';

type Petition = NonNullable<EndorsementsLayoutPageDataQuery['petition']>;

export function computePetitionStrengthScore(petition: Petition): number {
	let totalPointsAchieved = 0;
	if (petition.description.length < 500) {
		totalPointsAchieved += 2;
	} else if (petition.description.length < 2000) {
		totalPointsAchieved += 3;
	} else if (petition.description.length >= 2000) {
		totalPointsAchieved += 5;
	}

	if (petition.photo?.petitionLarge) {
		totalPointsAchieved += 3;
	}

	if ((petition.decisionMakersConnection.totalCount || 0) > 0) {
		totalPointsAchieved += 1;
	}

	if ((petition.tagsConnection?.nodes.length || 0) > 1) {
		totalPointsAchieved += 1;
	}
	return totalPointsAchieved;
}
